import MobxState from '../../abstract/MobxState';
import { createObservableInstance } from '../../helpers';
import TenanciesState from './TenanciesState';

class TenantState extends MobxState {
  init() {
    super.init();

    console.log('[TenantState][init]');

    this.tenancies = createObservableInstance(TenanciesState, this.root);
  }

  destroy() {
    super.destroy();

    this.tenancies.destroy();
  }
}

TenantState.annotations = {
  ...MobxState.annotations,
};

export default TenantState;
